<template>
    <el-dialog v-dialogDrag class="dialog" width="1280px" :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑流程
            </div>
        </div>
        <div class="dialog_body">
            <iframe name="mainFrame" id="mainFrame" frameborder="0" :src="serverurl"
                    style="margin:0 auto;width:100%;height:695px;"></iframe>
        </div>

    </el-dialog>

</template>

<script>

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {},
        data() {
            return {
                serverurl: "",
                modelId: "322501",
                curl: window.location.href,
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
            };
        },
        async mounted() {
            this.serverurl = window.host.ProjectUrl + "/activiti-editor/editor.html?modelId=" + this.formData.ID_ + "&curl=" + window.location.href;
        },
        methods: {
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
        }
    }
</script>

<style scoped>
    .dialog /deep/ .el-form-item__label {
        background-color: #c8ddf3;
        line-height: 38px;
        text-align: center;
        border: 1px solid rgba(0, 0, 0, 0.1);;
    }

    .dialog .bzClass /deep/ .el-form-item__label {
        line-height: 75px;
        height: 75px;
    }

    .dialog /deep/ .el-textarea__inner {
        background-color: #daecfa;
    }

    .dialog /deep/ .el-textarea .el-input__count {
        background-color: #daecfa;
    }

    .dialog /deep/ .el-form-item__content {
        line-height: 40px;
    }

    .dialog /deep/ .el-form-item {
        margin-bottom: 6px;
    }

    .dialog /deep/ .el-form-item__error {
        z-index: 10;
    }

    .dialog /deep/ .el-input__inner {
        background-color: #daecfa;
        height: 40px;
        line-height: 40px;
    }

    .dialog /deep/ .el-dialog__header {
        padding: 0;
        text-align: center;
    }

    .dialog /deep/ .el-dialog__headerbtn {
        top: 8px;
        right: 10px
    }

    .dialog /deep/ .el-dialog__headerbtn .el-dialog__close {
        color: #FFF;
    }


    .dialog /deep/ .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 0px;
    }

    .dialog .dialog_title {
        background-color: rgba(28, 136, 201, 0.6);
        padding: 5px 10px 5px;
    }

    .dialog .dialog_body {
        border-left: 10px solid rgba(28, 136, 201, 0.6);
        border-right: 10px solid rgba(28, 136, 201, 0.6);
        border-bottom: 10px solid rgba(28, 136, 201, 0.6);
        background-color: rgba(193, 245, 236, 0.15);
    }

    .dialog /deep/ .el-input-group__append {
        background-color: rgba(14, 129, 248, 0.48);
        color: #000;
    }
</style>
